import { Link } from "react-router-dom";
import { UtensilsCrossed } from "lucide-react";

export function AuthShell({ title, subtitle, children, footer }) {
  return (
    <div className="flex min-h-screen bg-slate-50">
      <div className="hidden flex-1 flex-col justify-between bg-gradient-to-br from-emerald-600 to-emerald-500 p-12 text-white lg:flex">
        <Link to="/" className="flex items-center gap-2 font-heading text-2xl font-bold">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/20">
            <UtensilsCrossed className="h-5 w-5" />
          </span>
          Smart Menu
        </Link>
        <div>
          <h2 className="font-heading text-4xl font-bold leading-tight">
            Run your restaurant, not your software.
          </h2>
          <p className="mt-4 max-w-md text-emerald-50/90">
            QR ordering, menu management, GST invoices and subscriptions — in one place.
          </p>
        </div>
        <p className="text-sm text-emerald-50/70">Trusted by modern kitchens across India.</p>
      </div>

      <div className="flex flex-1 items-center justify-center px-5 py-10">
        <div className="w-full max-w-md sm-fade-up">
          <Link to="/" className="mb-8 flex items-center gap-2 font-heading text-xl font-bold text-slate-900 lg:hidden">
            <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-emerald-500 text-white">
              <UtensilsCrossed className="h-5 w-5" />
            </span>
            Smart Menu
          </Link>
          <h1 className="font-heading text-2xl font-bold text-slate-900 sm:text-3xl">{title}</h1>
          {subtitle && <p className="mt-2 text-sm text-slate-500">{subtitle}</p>}
          <div className="mt-7">{children}</div>
          {footer && <div className="mt-6 text-center text-sm text-slate-500">{footer}</div>}
        </div>
      </div>
    </div>
  );
}

export function Field({ label, children }) {
  return (
    <div>
      <label className="mb-1.5 block text-sm font-medium text-slate-700">{label}</label>
      {children}
    </div>
  );
}
